import { useDispatch } from "react-redux";
import {
  readChurchPrayersAction,
  readMinistryPrayersAction,
  readChannelPrayersAction,
} from "../../../store/Prayer/PrayersAction";

export const AllPrayersHooks = () => {
  const dispatch = useDispatch();

  /**
   * Generic fetch function for Church / Ministry / Channel prayers
   */
  const fetchPrayers = (
    page,
    limit,
    searchCriteria = {},
    callbackFn,
    entityType = "church", // "church" | "ministry" | "channel"
    entityObjId = ""
  ) => {
    let action;
    let payloadKey;

    switch (entityType) {
      case "ministry":
        action = readMinistryPrayersAction;
        payloadKey = "ministriesObjId";
        break;

      case "channel":
        action = readChannelPrayersAction;
        payloadKey = "channelObjId";
        break;

      default:
        action = readChurchPrayersAction;
        payloadKey = "churchObjId";
    }

    dispatch(
      action({
        data: {
          page,
          limit,
          [payloadKey]: entityObjId,
        },
        callback: (Data) => {
          if (Data?.type === 1) {
            let prayers = Data?.data || [];

            // 🔍 Search
            if (searchCriteria.searchText) {
              const text = searchCriteria.searchText.toLowerCase();
              prayers = prayers.filter(
                (p) =>
                  p.subject?.toLowerCase().includes(text) ||
                  p.prayer_request?.toLowerCase().includes(text) ||
                  `${p.user?.firstName || ""} ${p.user?.lastName || ""}`
                    .toLowerCase()
                    .includes(text)
              );
            }

            const startIndex = (page - 1) * limit;
            const endIndex = startIndex + limit;

            callbackFn?.({
              data: prayers.slice(startIndex, endIndex),
              total: prayers.length,
              page,
              limit,
            });
          } else {
            callbackFn?.({
              data: [],
              total: 0,
              page,
              limit,
            });
          }
        },
      })
    );
  };

  return { fetchPrayers };
};
